const initialState = {
  interestRate: null,
  monthlyPayment: null,
  cashBackAmount: null,
  term: null,
}

const selectedTerms = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SELECTED_TERMS':
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export default selectedTerms

export const selectSelectedTerms = (state) => {
  return state.refis.selectedTerms || {}
}
